import { render, staticRenderFns } from "./DownloadModal.vue?vue&type=template&id=0a3ccd55&scoped=true"
import script from "./DownloadModal.vue?vue&type=script&lang=js"
export * from "./DownloadModal.vue?vue&type=script&lang=js"
import style0 from "./DownloadModal.vue?vue&type=style&index=0&id=0a3ccd55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3ccd55",
  null
  
)

export default component.exports